<template>
  <div class="app-aside">
    <div :class="[isFlod ? 'aside-menu' : 'aside-menu-collapse']">
      <div style="background: var(--menu-logo-bg); width: 100%;height:40px;">
        <img :class="[isFlod ? 'logodz' : 'logo']" :src="logoImg" alt="" />
      </div>
      <el-menu
        :default-active="activeItem"
        class="el-menu-vertical-demo"
        @open="handleOpen"
        @close="handleClose"
        :collapse="!isFlod"
        :unique-opened="true"
      >
        <!-- <transition-group name="sidebar"> -->
        <template v-for="route in sidebarMenu">
          <SidebarItem :key="route.path" :item="route" @clickMenu="selectMenu" />
        </template>
        <!-- </transition-group> -->
      </el-menu>
    </div>
    <div>
      <img v-show="isFlod" class="collapseImg" :src="getToggleIcon('collapse')" @click="collapseMenu" />
      <img v-show="!isFlod" class="openImg" :src="getToggleIcon('open')" @click="openMenu" />
    </div>
  </div>
</template>

<script>
import SidebarItem from '@/components/AsideMenu/SidebarItem';
export default {
  data() {
    return {
      logoImg: require('../../assets/images/light/logodz.png'),
      isFlod: true,
      activeItem: '/homeboard'
    };
  },
  computed: {
    sidebarMenu() {
      return this.$store.state.permission.sidebarRouters;
    },
    isDarkTheme() {
      return this.$store.state.app.theme === 'dark';
    }
  },
  watch: {
    // 当isFlod变化时，这个函数就会被调用
    isFlod(newValue) {
      this.$emit('updateFlod', newValue);
      this.updateLogoImg();
    },
    isDarkTheme() {
      this.updateLogoImg();
    }
  },
  components: {
    SidebarItem
  },
  mounted() {
    this.updateLogoImg();
  },
  methods: {
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
      // this.isFlod = true;
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
      // this.isFlod = false;
    },
    collapseMenu() {
      this.isFlod = false;
      this.updateLogoImg();
    },
    openMenu() {
      this.isFlod = true;
      this.updateLogoImg();
    },
    // 根据主题和展开状态更新logo
    updateLogoImg() {
      if (this.isDarkTheme) {
        this.logoImg = this.isFlod
          ? require('../../assets/images/dark/logodz.png')
          : require('../../assets/images/dark/logo.png');
      } else {
        this.logoImg = this.isFlod
          ? require('../../assets/images/light/logodz.png')
          : require('../../assets/images/light/logo.png');
      }
    },
    // 根据主题获取折叠/展开按钮图标路径
    getToggleIcon(name) {
      const folder = this.isDarkTheme ? 'dark' : 'light';
      return require(`@/assets/images/${folder}/${name}.png`);
    },
    // 左侧菜单选中事件
    async selectMenu(value) {
      let index = value.path;
      if(index.indexOf("/")!=0){//最前面没有带“/”
        index = "/"+index;
      }
      // 如果路由是两级
      if(value.parentRoute && value.parentRoute!="/"){
        index = value.parentRoute+""+index;
      }
      
      this.activeItem = index;
      let hostUrl = window.location.origin;
      let pageUrl = `${hostUrl}/#${index}`;
      window.location.href = pageUrl;
      let data = {
          path:index,
          icon:value.meta.icon,
          title:value.meta.title||value.children[0].meta.title,
          name:value.name
      }
      this.$store.commit('app/mutationSelectTabs', data);
    }
  }
};
</script>

<style lang="scss" scope>
.app-aside {
  display: flex;
  z-index: 999;
  .logodz {
    width: 210px;
    height: 38px;
  }
  .logo {
    width: 38px;
    height: 38px;
    margin-left: 14px;
  }
  .aside-menu {
    width: 210px;
    background: var(--menu-bg);
  }
  .aside-menu-collapse {
    width: 64px;
    background: var(--menu-bg);
  }
  .el-menu {
    border-right: 0;
    overflow-y: hidden;
    height: calc(100% - 40px);
    overflow-x: hidden;
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 100%;
    min-height: 400px;
    overflow-y: auto;
  }
  .el-menu--collapse {
    .el-menu-item,
    .el-submenu__title {
      span {
        display: none;
        font-size: 28px;
      }
    }
  }
  .el-menu-item,
  .el-submenu__title {
    height: 40px;
    line-height: 40px;
  }
  // 一级菜单右侧箭头位置
  .el-submenu__icon-arrow {
    right: 3px;
  }
  .el-submenu__title:hover {
    color: var(--menu-active-text);
    background-color: var(--menu-active-bg);
    i {
      color: var(--menu-active-text);
    }
  }
}
.el-menu-item.is-active,
.el-menu-item:focus,
.el-menu-item:hover {
  color: var(--primary-color);
  background: rgba(64, 158, 255, 0.2);
  i {
    color: var(--primary-color);
  }
}
.collapseImg {
  position: absolute;
  left: 206px;
  cursor: pointer;
  padding: 11px 10px 9px;
  background-color: #fff;
}
.openImg {
  position: absolute;
  left: 64px;
  cursor: pointer;
  padding: 11px 10px 9px;
  background-color: #fff;
}
</style>
